// extracted by mini-css-extract-plugin
export default {"info":"Info_info__o1YP6","infoSvg":"Info_infoSvg__I6SVH"};